import React, { Component } from 'react';
import Joi from 'joi-browser';
import Input from './Common/input';
import * as userService from '../services/userService';
import { Link } from 'react-router-dom';
import Loader from './loader';

class ResetPassword extends Component {
  state = {
    data: { password: '', cpassword: '' },
    errors: {},
    notFound: false,
    loading: true,
  };

  async componentDidMount() {
    window.scrollTo(0, 0);

    await this.verifyToken();
    this.setState({ loading: false });
    console.log(this.state.userInfo);
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  verifyToken = async () => {
    const token = this.props.match.params.token;
    console.log(token);
    try {
      const response = await userService.verfiyResetLink(token);

      if (response.data.message === 'password reset link a-ok') {
        this.setState({
          userInfo: response.data.user,
        });
      }
    } catch (error) {
      console.log(error.response.data);
      this.setState({
        notFound: true,
      });
    }
  };

  schema = {
    password: Joi.string().required().min(5).max(15).label('Password'),
    cpassword: Joi.any()
      .valid(Joi.ref('password'))
      .required()
      .label('Confirm Password')
      .options({ language: { any: { allowOnly: 'must match' } } }),
  };

  validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);
    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;

    const { password } = data;
    if (input.value === password) delete errors[input.name];

    this.setState({ data, errors });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) return;

    this.doSubmit();
  };

  doSubmit = async () => {
    try {
      const { userInfo } = this.state;
      this.setState({ isProcessing: true });

      const { password } = this.state.data;
      userInfo.password = password;

      await userService.updateUser(userInfo);

      this.props.handleNotification({
        message: 'Password updated successfully!',
        img: '/img/success.png',
      });

      this.props.history.push('/login/');
    } catch (ex) {
      if (
        (ex.response && ex.response.status === 400) ||
        (ex.response && ex.response.status === 403)
      ) {
          
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
      }
    }
  };

  render() {
    const { data, errors, notFound, loading } = this.state;

    if (loading) return <Loader />;

    if (notFound) {
      return (
        <div className='not-found'>
          <p>Password reset link is invalid or has expired</p>
          <Link to='/login/'>
            <button className='explore-categories'>Back to login</button>
          </Link>
        </div>
      );
    }

    return (
      <div className='login-page'>
        <div className='row'>
          <div className='col-md-3'></div>

          <div className='col-md-6 login-page-form'>
            <h1>Update your password?</h1>
            <form onSubmit={this.handleSubmit}>
              <label htmlFor=''>Enter new password</label>
              <Input
                type='password'
                placeholder='New password'
                name='password'
                value={data.password}
                onChange={this.handleChange}
                error={errors.password}
              />
              <Input
                type='password'
                placeholder='Confirm password'
                name='cpassword'
                value={data.cpassword}
                onChange={this.handleChange}
                error={errors.cpassword}
              />

              <p>
                <Link to='/login/'>
                  <i>Back to login</i>
                </Link>
              </p>

              <button disabled={this.validate()} className='login-btn'>
                Update password
              </button>
            </form>
          </div>

          <div className='col-md-3'></div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
